import { useEffect, useState } from "react";
import Lenis from "lenis";
import { motion, AnimatePresence } from "framer-motion";
import "@/App.css";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Intro from "@/components/site/Intro";
import Services from "@/components/site/Services";
import Process from "@/components/site/Process";
import Work from "@/components/site/Work";
import Founders from "@/components/site/Founders";
import Differential from "@/components/site/Differential";
import FinalCta from "@/components/site/FinalCta";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import { Toaster } from "@/components/ui/sonner";

const IntroOverlay = () => (
  <motion.div
    className="fixed inset-0 z-[100] flex items-center justify-center bg-royal"
    initial={{ y: 0 }}
    exit={{ y: "-100%", transition: { duration: 0.9, ease: [0.76, 0, 0.24, 1] } }}
    data-testid="intro-overlay"
  >
    <motion.img
      src="/assets/logo-white.png"
      alt="Creative"
      className="w-64 max-w-[70vw]"
      initial={{ opacity: 0, scale: 0.92, filter: "blur(8px)" }}
      animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
    />
  </motion.div>
);

function App() {
  const [intro, setIntro] = useState(true);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    const t = setTimeout(() => setIntro(false), 1400);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="App">
      <AnimatePresence>{intro && <IntroOverlay />}</AnimatePresence>
      <Navbar />
      <main>
        <Hero />
        <Marquee dark />
        <Intro />
        <Services />
        <Process />
        <Work />
        <Founders />
        <Marquee />
        <Differential />
        <FinalCta />
        <Contact />
      </main>
      <Footer />
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
